export function arrayify<T>(x: T) {
  if (Array.isArray(x)) return x
  return [x]
}
